<script>
    import { format, formatDistanceToNow } from 'date-fns';

    export default {
        filters: {
            formatDistance(value) {
                if (!value) { return ''; }
                const formatted = formatDistanceToNow(
                    new Date(value.replace(/-/g, '/') + ' UTC'),
                    { addSuffix: true },
                );

                return formatted.replace(' days', 'd')
                    .replace(' day', 'd')
                    .replace(' month', 'm')
                    .replace(' months', 'm')
                    .replace('over', 'm')
                    .replace('about', '');
            },

            dateFormat(value) {
                if (!value) { return ''; }
                return format(
                    new Date(value.replace(/-/g, '/') + ' UTC'),
                    'do MMM, YYY',
                );
            },
        },
    };
</script>
